import { queryAll, query, fromId } from '../utils/utils.js';
import instantsearch from 'instantsearch.js';

import algoliasearch from "algoliasearch";
import {
	configure,
	hits,
	pagination,
	searchBox,
	stats,
	currentRefinements,
	clearRefinements,
	refinementList,
	sortBy
} from 'instantsearch.js/es/widgets';
import historyRouter from 'instantsearch.js/es/lib/routers/history';
import { connectAutocomplete, connectCurrentRefinements, connectClearRefinements, connectSearchBox } from 'instantsearch.js/es/connectors';
import { radiusList } from '../parts/search-radius.js';
import { searchScroll } from '../parts/search-scroll.js';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { setAaInputAriaLabel, setHiddenSortSelectAriaLabel } from './accessibility-helpers.js';

const LOCATION_SEARCH_ARIA_LABEL = 'Search locations';

export class LocationSearch {
	constructor() {
		// this.init();
	}

	init() {
		let doViewAll = false;
		const instantSearchRouter = historyRouter();
		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX+'locations',
			searchClient: algoliasearch(
				'LTCGWA12RB',
				'fbbd5f8b545361104df6b21dfd244cc1'
			),
			routing: instantSearchRouter,
			// searchFunction(helper) {
			// 	if (helper.state.query && helper.state.index === "locations") {
			// 	  helper.search();
			// 	}
			// },
		});
		const virtualSearchBox = connectSearchBox(() => {});

		const createDataAttribtues = refinement =>
			Object.keys(refinement)
				.map(key => `data-${key}="${refinement[key]}"`)
				.join(' ');

		const renderRefinementListItem = ({ item, createURL }) => `
				${item.refinements
				.map(refinement => `<div href="${createURL(refinement)}" class="bhs-link-button primary-btn light ">${refinement.value}  <button ${createDataAttribtues(refinement)}><span class="icon icon-exit"></span></button></div>`)
				.join('')}
			`;
		const renderCurrentRefinements = (renderOptions, isFirstRender) => {
			const { items, refine, createURL } = renderOptions;

			const container = document.querySelector('#refinement-list');

			container.innerHTML = `
			  <div class="refinements">
				${items.map(item => renderRefinementListItem({ item, createURL })).join('')}
				<div class="hi"></div>
			  </div>
			`;

			let hasTypeFilter = false;
			items.forEach(item => {
				if (item.attribute === "type") {
					hasTypeFilter = true;
				}
			});
			if (hasTypeFilter) {
				document.querySelector('.type-chooser-holder').classList.add("hide")
			} else {
				document.querySelector('.type-chooser-holder').classList.remove("hide")
			}

			[...container.querySelectorAll('button')].forEach(element => {
				element.addEventListener('click', event => {
					const item = Object.keys(event.currentTarget.dataset).reduce(
						(acc, key) => ({
							...acc,
							[key]: event.currentTarget.dataset[key],
						}),
						{}
					);

					console.log("clicked", item);
					refine(item);
				});
			});
		};

		const customCurrentRefinements = connectCurrentRefinements(
			renderCurrentRefinements
		);

		const renderClearRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#reset-filters').innerHTML = `
					<a href=${createURL()}>Reset Filters</a>
				`;
			}
			if (!canRefine) {
				document.querySelector('#reset-filters').innerHTML = ``;
			}
		};

		const customClearRefinements = connectClearRefinements(
			renderClearRefinements
		);

		const renderClearAltRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#reset-type-filter').innerHTML = `
					<div class="item-type item ">
						<a href="${createURL()}" >
							<span>View All Locations</span>
						</a>
					</div>
				`;
			}
			if (!canRefine) {
				document.querySelector('#reset-type-filter').innerHTML = ``;
			}
		};

		const customClearAltRefinements = connectClearRefinements(
			renderClearAltRefinements
		);

		search.addWidgets([
			virtualSearchBox({}),
			configure({
				hitsPerPage: 12,
				aroundRadius: 10000
			}),
			stats({
				container: '#stats',
				templates: {
					text(data, { html }) {
						if (data.hasManyResults || data.hasOneResult) {
							return html`<h4>Search Results (${data.nbHits})</h4>`;
						}
						return html`<h4>Search Results (0)</h4>`;
					}
				}
			}),
			stats({
				container: '#bottom-stats',
				templates: {
					text(data, { html }) {
						if (data.hasManyResults || data.hasOneResult) {
							let showing = data.page * data.hitsPerPage;
							if (data.page === 0) {
								if (data.nbHits < data.hitsPerPage) {
									showing = data.nbHits;
								} else {
									showing = data.hitsPerPage;
								}
							} else if (data.page >= 1) {
								showing = (data.page * data.hitsPerPage + 1) + "-" + (data.page * data.hitsPerPage + data.hitsPerPage);
							}
							return html`<p>Showing ${showing}  of ${data.nbHits} results</p>`;
						}
						return html``;
					}
				}
			}),
			radiusList({ container: '#location-distance' }),
			customCurrentRefinements({
				container: '#refinement-list',
			}),
			//big boxes
			refinementList({
				container: '#type-chooser',
				attribute: 'type',
				operator: 'or',
				sortBy: ['name:asc'],
				limit: 7,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;
						let icon = label.toLocaleLowerCase().replaceAll(" ", "-");
						if (icon === "hospitals") {
							icon = "hospitals";
						}
						if (icon === "primary-care") {
							icon = "primary-care";
						}

						return html`
					  	<div class="item-type item ${isRefined ? 'checked' : ''}">
							<a href="${url}" >
						  		<div class="icon icon-${icon}"></div>
								<span>${label}</span>
							</a>
						</div>
					  `;
					},
				},

			}),
			//drop down chooser
			refinementList({
				container: '#location-types',
				attribute: 'type',
				operator: 'or',
				limit: 7,
				sortBy: ['name:asc'],
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;

						return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" >
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				},

			}),
			refinementList({
				container: '#location-city',
				attribute: 'city',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;
						if (label === ",") {
							return false;
						}

						return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				},

			}),
			sortBy({
				container: '#hidden-sort-by',
				items: [
					{ label: 'Relevancy', value: 'locations' },
					{ label: 'Sort Alphabetically (A-Z)', value: 'location_asc' },
					{ label: 'Sort Alphabetically (Z-A)', value: 'location_desc' },
				],
			}),

			refinementList({
				container: '#location-refine-city',
				attribute: 'city',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;
						if (label === ",") {
							return false;
						}

						return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				},
			}),
			refinementList({
				container: '#location-refine-center-type',
				attribute: 'c_type',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;

						return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				},

			}),

			refinementList({
				container: '#location-refine-pharmacy-type',
				attribute: 'p_type',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;

						return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				},

			}),

			//clear all filters
			customClearRefinements({
				container: '#reset-filters',
			}),
			//clear only the type filter
			// customClearAltRefinements({
			// 	container: '#reset-type-filter',
			// 	attribute: 'type'
			// }),
			hits({
				container: "#hits",
				templates: {
					empty(results, { html }) {
						return html`<div class="no-results">No results found for <q>${results.query}</q></div>`;
					},
					item(hit, { html, components }) {
						// console.log(hit);
						let hours = "";
						try {
							hours = hit.hours.map((hour) => {
								return html`<div class="hour">${html(hour.item)}</div>`;
							});
						} catch (e) {

						}

						let address1 = "";
						let address2 = "";
						let address3 = "";
						let address_string = "";
						//Maybe use lat+long in the google link?
						console.log(hit, hit._geoloc, hit._geoloc?.lat, hit._geoloc?.lng);
						try{
							let address_parts = hit.address.split("<br/>");
							console.log(address_parts);
							address1 = address_parts[0];
							address2 = address_parts[1];
							if(address_parts[2] !== undefined && address_parts[2] !== null && address_parts[2] !== ""){
								address3 = ", "+address_parts[2];
							}
							address_string = address1 +" "+ address2+" "+ address3;
							address_string = strtolower(address_string);
							//remove "First floor", "Second floor", etc from address_string
							address_string = address_string.replace(/, first floor/g, "").replace(/, second floor/g, "").replace(/, third floor/g, "").replace(/, fourth floor/g, "").replace(/, fifth floor/g, "");

						}catch(e){
						}

						let address_link = "https://maps.google.com?daddr="+address_string;
						if(hit._geoloc != undefined && hit._geoloc?.lat != undefined && hit._geoloc?.lng != undefined){
							address_link = `https://www.google.com/maps/search/?api=1&query=${hit._geoloc?.lat},${hit._geoloc?.lng}`;
						}

						if(hit.address_link != undefined && hit.address_link != ""){
							address_link = hit.address_link;
						}

						if(hit.region != ""){
							hit.region = hit.region + " County";
						}

						let fax = "";
						if(hit.fax == ""){
							fax = `display:none`;
						}

						console.log(fax, hit.fax);

						return html`
						<div class="search-result location-card card">
							<div class="details">
								<div class="details-top">
									<div class="topline">${hit.region}</div>
									<a href="${hit.url}" class="title">${hit.title}</a><br/>
									<div class="topline">${hit.affiliation}</div>
									<div class="hours">
										${hours}
									</div>
								</div>
								<div class="details-bottom">
									<div class="phone"><a href="tel:${hit.phone}">P: ${hit.phone}</a></div>
									<div class="phone" style="${fax}"><a href="tel:${hit.fax}">F: ${hit.fax}</a></div>
									<div class="address">
										<div class="address-details">
											${address1}${address3}<br/>${address2}<br/>
											<A class="directions" href="${address_link}" target="_blank">Get Directions</a>
										</div>
										<div class="address-cta card-cta">
											<a href="${hit.url}" class="bhs-link-button arrow-link icon-btn light"></a><br/>
										</div>
									</div>
								</div>
							</div>
						</div>
					`;
					},
				},
			}),
			pagination({
				container: '#pagination',
				padding: 2,
				scrollTo: '#search-results',
			}),
		]);

		search.start();
		setHiddenSortSelectAriaLabel();
		let firstRender = true;
		searchScroll();

		search.on('render', () => {
			setHiddenSortSelectAriaLabel();
			setAaInputAriaLabel('#searchbox', LOCATION_SEARCH_ARIA_LABEL);
			window.addArrowLinks();

			// hide pagination if there is only one page
			if (search.helper?.lastResults?.nbPages == 1) {
				document.querySelector('#pagination').classList.add("hide")
			} else {
				document.querySelector('#pagination').classList.remove("hide")
			}

			if (search.helper?.lastResults?.hits.length === 0) {
				document.querySelector('.search-page').classList.add("no-results-found")
			} else {
				document.querySelector('.search-page').classList.remove("no-results-found")
			}

			if (firstRender) {
				firstRender = false;
				const input = document.querySelector('#searchbox .aa-Input');
				input.addEventListener('input', () => {
					if (input.value.length <= 2) {
						document.querySelector('#body-autocomplete').classList.remove('show');
					} else {
						document.querySelector('#body-autocomplete').classList.add('show');
					}
				});
				input.addEventListener('blur', () => {
					setTimeout(() => {
						document.querySelector('#body-autocomplete').classList.remove('show');
					}, 150);
				});
			}

			if (query('.location-view-all') === null && query('#type-chooser .ais-RefinementList-list') !== null) {
				//append view all to locations type list
				document.querySelector('#type-chooser .ais-RefinementList-list').insertAdjacentHTML('beforeend', `
				<li class="ais-RefinementList-item">
					<div>
						<div class="item-type item location-view-all">
							<a href="#" >
								<span>View All Locations</span>
							</a>
						</div>
					</div>
				</li>
				`);

				query('.location-view-all a').addEventListener('click', (event) => {
					event.preventDefault();
					console.log("here");
					doViewAll = true;
					search.setUiState((uiState) => ({
						...uiState,
						[window.ALGOLIA_INDEX_PREFIX+"locations"]: {
							...uiState[window.ALGOLIA_INDEX_PREFIX+"locations"],
							page: 1,
							refinementList: {
								...uiState[window.ALGOLIA_INDEX_PREFIX+"locations"].refinementList,
								type: [],
							}
						},
					}));
				});

			}

			//conditionally hide filters
			if (search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.refinementList?.c_type?.items?.length < 1) {
				document.querySelector('.dropdown-c-type').classList.add("hide")
			} else {
				document.querySelector('.dropdown-c-type').classList.remove("hide")
			}
			if (search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.refinementList?.p_type?.items?.length < 1) {
				document.querySelector('.dropdown-p-type').classList.add("hide")
			} else {
				document.querySelector('.dropdown-p-type').classList.remove("hide")
			}
			if (search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.refinementList?.city?.items?.length < 1) {
				document.querySelector('.dropdown-city').classList.add("hide")
			} else {
				document.querySelector('.dropdown-city').classList.remove("hide")
			}

			if (search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.refinementList?.type?.items?.length < 1) {
				// doViewAll = true;
			}

			//search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.hits?.hits?.length >= 1
			// console.log(search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.searchBox?.query, doViewAll);
			// if(doViewAll || search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.searchBox?.query !== ""){
			// 	document.querySelector('.search-results-holder').classList.remove("hide")
			// }


			//update the custom sort selected index
			const sortLinks = document.querySelectorAll('#sort-by a');
			document.querySelectorAll('#sort-by .checked').forEach(el => el.classList.remove('checked'));
			const currentSort = search.renderState[window.ALGOLIA_INDEX_PREFIX+"locations"]?.sortBy?.currentRefinement;

			sortLinks.forEach((link) => {
				if (link.parentNode.classList.contains("item-" + currentSort)) {
					link.parentNode.classList.add('checked');
				}
			});

			// make search results clickable
			queryAll('.ais-Hits-list .ais-Hits-item .card').forEach((card) => {
				const button = card.querySelector('.bhs-link-button');
				card.querySelectorAll('a').forEach((a) => {

					if (!a.classList.contains('bhs-link-button')) {
						a.addEventListener('click', (e) => {
							e.stopPropagation();
						});
					}

				});

				if (button) {
					card.addEventListener('click', (e) => {
						button.click();
					});
					card.addEventListener('mouseover', (e) => {
						button.classList.add('hover');
					});
					card.addEventListener('mouseout', (e) => {
						button.classList.remove('hover');
					});
				}
			});


			const setSearch = (query) => {
				setInstantSearchUiState({
					query: decodeURIComponent(query),
				});
				setTimeout(() => {
					document.querySelector('#body-autocomplete').classList.remove('show');
				}, 150);
			};
			window.setSearch = setSearch;

		});


		const setInstantSearchUiState = (indexUiState) => {
			search.setUiState((uiState) => ({
				...uiState,
				[window.ALGOLIA_INDEX_PREFIX+"locations"]: {
					...uiState[window.ALGOLIA_INDEX_PREFIX+"locations"],
					// We reset the page when the search state changes.
					page: 1,
					...indexUiState,
				},
			}));
		}

		const getInstantSearchUiState = () => {
			const uiState = instantSearchRouter.read();

			return (uiState && uiState[window.ALGOLIA_INDEX_PREFIX+"locations"]) || {};
		}

		const searchPageState = getInstantSearchUiState();

		let skipInstantSearchUiStateUpdate = false;
		const { setQuery } = autocomplete({
			container: '#searchbox',
			panelContainer: '#body-autocomplete',
			placeholder: 'Enter location name, keyword or zip code',
			openOnFocus: false,
			detachedMediaQuery: 'none',
			initialState: {
				query: searchPageState.query || '',
			},
			onSubmit({ state }) {
				setInstantSearchUiState({ query: state.query });
			},
			onReset() {
				setInstantSearchUiState({ query: '' });
			},
			onStateChange({ prevState, state }) {
				if (!skipInstantSearchUiStateUpdate && prevState.query !== state.query) {
				  setInstantSearchUiState({ query: state.query });
				}
				skipInstantSearchUiStateUpdate = false;
			},
			shouldPanelOpen(params){
				if(params?.state?.collections[0]?.items.length >= 1){
					document.querySelector('#body-autocomplete').classList.add('show');
					return true;
				}
				document.querySelector('#body-autocomplete').classList.remove('show');
				return false;
			},
			getSources() {
				return [
					{
						sourceId: 'querySuggestions',
						getItemInputValue: ({ item }) => item.query,
						getItems({ query }) {
							return getAlgoliaResults({
								searchClient: algoliasearch(
									'LTCGWA12RB',
									'fbbd5f8b545361104df6b21dfd244cc1'
								),
								queries: [
									{
										indexName: 'locations_autocomplete',
										query,
										params: {
											hitsPerPage: 4,
										},
									},
								],
							});
						},
						templates: {
							item({ html, item, components }) {
								return html`
									<ul class="search-suggestions">
										<li class="search-item">
											<a href="#/find-a-location?s=${encodeURIComponent(item.title)}" onClick=${(event) => {
												event.preventDefault();
												skipInstantSearchUiStateUpdate = true;
												window.setSearch(encodeURIComponent(item.title));
												setTimeout(() => {
													const input = document.querySelector('#searchbox .aa-Input');
													input.value = decodeURIComponent(item.title);
													document.querySelector('#search-results').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest'});
												}, 100);
											  }}>${item.title}</a>
										</li>
									</ul>
						  		`;
							},
						},
					},
				];
			},
		});

		setAaInputAriaLabel('#searchbox', LOCATION_SEARCH_ARIA_LABEL);

		window.addEventListener('popstate', () => {
			skipInstantSearchUiStateUpdate = true;
			setQuery(search.helper?.state.query || '');
		});

		if (query('#sort-by') !== null) {
			const sortLinks = document.querySelectorAll('#sort-by a');
			sortLinks.forEach((link) => {
				link.addEventListener('click', (event) => {
					event.preventDefault();
					link.parentNode.parentNode.querySelectorAll('.checked').forEach(el => el.classList.remove('checked'));
					link.parentNode.classList.add('checked');

					const select = document.querySelector('#hidden-sort-by select');
					const value = link.getAttribute("href").replace("#", "");
					for (let i = 0; i < select.options.length; i++) {
						if (select.options[i].value === value) {
							select.selectedIndex = i;
							break;
						}
					}
					select.dispatchEvent(new Event('change'));
				});
			});
		}
	}
}
